<!-- CPL行为标签流量定制组件 -->
<template>
  <div class="customize_box">
    <div class="box_inner" ref="cplLabel">
      <span class="title">CPR+标签：</span>
      <div class="label_str_wrap">
        <span ref="labelStr" :title="labelTip">
          <template v-if="labelCustomize.length === 1">
            <span v-for="(w, j) in labelCustomize[0]" :key="w.code">
              {{ w.name }}
              <span v-if="w.count >= 0" class="incre_value">{{ w.count > 0 ? '+' + w.count : '' }}</span>
              {{ j !== labelCustomize[0].length - 1 ? '+' : '' }}
            </span>
          </template>
          <template v-else>
            <span v-for="(tag, i) in labelCustomize" :key="i">
              {{ tag.length > 1 ? '(' : '' }}
              <span v-for="(w, j) in tag" :key="w.code">
                {{ w.name }}
                <span v-if="w.count >= 0" class="incre_value">{{ w.count > 0 ? '+' + w.count : '' }}</span>
                {{ j !== tag.length - 1 ? '+' : '' }}
              </span>
              {{ tag.length > 1 ? ')' : '' }}
              {{ i !== labelCustomize.length - 1 ? ' / ' : '' }}
            </span>
          </template>
        </span>
      </div>
      <div v-if="canCustomize" class="custom_flow" @click="customFlowPop">定制流量</div>
    </div>

    <fix-centerv1 v-dialogDrag v-model="showCustomize" w="390" h="342" @close="closeDialog">
      <template slot="title">定制流量</template>
      <div slot="main" class="custom_flow_popbox">
        <div class="describe">
          <span>流量定制功能仅支持行为标签</span>
          <el-popover popper-class="custom_flow_rule" trigger="manual" placement="bottom-end" v-model="showRule">
            <div slot="reference" class="rule_tip" @click="showRule = !showRule">
              <span style="margin-right: 5px;">{{ showRule ? '收起' : '规则详情' }}</span>
              <i :class="['el-icon-arrow-up', showRule ? 'reverse' : '']"></i>
            </div>
            <div class="rule_list">
              <p>行为标签的数量为S, 总触达流量为R, 则目标流量L的计算规则如下：</p>
              <p class="rule_item">(1). 若S&lt;=R，L=S；若S>R，L=R；</p>
              <p class="rule_item">(2). 可根据业务约定，定制<span class="stress">&nbsp;增量+N：(S)new=S*(1+N) </span>，但 L 需满足规则(1)。</p>
            </div>
          </el-popover>
        </div>
        <div v-for="t in labelCustomize.flat(1).filter(e => e.count === undefined || e.count >= 0)" :key="t.code" class="one_item">
          <span>{{ t.name }}</span>
          <div class="item_r">
            <span>流量：</span>
            <img v-if="t.count === 0" class="icon_minus disable" src="../../../assets/minus_gray.png"/>
            <img v-else class="icon_minus" src="../../../assets/minus.png" @click="countMinus(t)"/>
            <el-input-number
              class="count_input"
              size="mini"
              placeholder="请输入"
              :disabled="true"
              :controls="false"
              :min="0"
              :max="3"
              :step="1"
              v-model="t.count"
              @change="(v) => countChange(v, t)">
            </el-input-number>
            <img v-if="t.count >= 3" class="icon_plus disable" src="../../../assets/plus_gray.png"/>
            <img v-else class="icon_plus" src="../../../assets/plus.png" @click="countPlus(t)"/>
          </div>
        </div>
      </div>
      <template slot="btm">
        <div class="fix-btn red" @click="confirmAction">确认</div>
        <div class="fix-btn" @click="cancelAction">取消</div>
      </template>
    </fix-centerv1>
  </div>
</template>

<script>
import { addResizeListener, removeResizeListener } from 'element-ui/lib/utils/resize-event'
import { deepClone } from '@/utils/functions'

export default {
  name: 'FlowCustomize',
  props: {},
  data() {
    return {
      labelCustomize: [], // 定制流量标签数组对象
      validLabel: [], // 最终传递给外部的定制流量数据对象
      labelTip: '',
      showCustomize: false,
      showRule: false
    }
  },
  computed: {
    code2LabelDto() {
      return this.$store.state.label.codeMap
    },
    // 用户标签编码
    personCodes() {
      return this.$store.state.label.confirm.persons
    },
    // 是否可以定制流量(选择了【行为标签】,排除"玩手机"(H1))
    canCustomize() {
      const bhs = (this.personCodes || []).filter(portrait => {
        return portrait.length && portrait.some(e => e.startsWith('H') && e !== 'H1')
      })
      return bhs.length > 0
    },
    fullLabelName() {
      if (this.labelCustomize.length > 0) {
        return this.labelCustomize.map(tag => {
          const str = tag.map(({ name, count }) => {
            return count > 0 ? `${name}+${count}` : name
          }).join('+')
          return tag.length > 1 ? `(${str})` : str
        }).join(' / ')
      }
      return ''
    }
  },
  beforeDestroy() {
    removeResizeListener(this.$refs.cplLabel, this.handleResize)
  },
  created() {
    // 深拷贝一次,方便增加定制流量相关属性
    this.labelCustomize = (deepClone(this.personCodes) || []).map(portrait => {
      return portrait.map(e => {
        return {
          code: e,
          count: (e.startsWith('H') && e !== 'H1') ? 0 : -1, // 行为标签初始值为0,非行为标签赋-1
          name: this.code2LabelDto[e].name
        }
      })
    })
  },
  mounted() {
    this.deliverLabelData()
    addResizeListener(this.$refs.cplLabel, this.handleResize)
  },
  methods: {
    handleResize() {
      if (this.$refs.cplLabel && this.$refs.labelStr) {
        const btnwidth = this.canCustomize ? 66 : 0
        const cw = this.$refs.cplLabel.clientWidth - 20 - 82 - btnwidth // 减去右内边距20、"CPR+标签:"、"定制流量"占用宽度
        this.labelTip = (cw + 1) < this.$refs.labelStr.offsetWidth ? this.fullLabelName : ''
      }
    },
    customFlowPop() {
      this.showCustomize = true
    },
    countMinus(dto) {
      dto.count -= 1
    },
    countPlus(dto) {
      dto.count += 1
    },
    countChange(v, dto) {
      // 如果用户删除输入框内容,则将值重置为0
      if (v === undefined) {
        this.$nextTick(() => {
          dto.count = 0
        })
      }
    },
    // 拷贝用户操作后的订单流量数据并传递给外部
    deliverLabelData() {
      this.validLabel = deepClone(this.labelCustomize)
      const transfer = this.validLabel.flat(1).map(({ code, count, name }) => {
        return { name, code, countValue: Math.max(0, count) }
      })
      this.$emit('customize', transfer)
    },
    confirmAction() {
      this.showRule = false
      this.deliverLabelData()
      this.showCustomize = false
      this.handleResize()
    },
    cancelAction() {
      this.showRule = false
      this.labelCustomize = deepClone(this.validLabel) // 数据回退到用户操作前的状态
      this.showCustomize = false
    },
    closeDialog() {
      this.showRule = false
      this.labelCustomize = deepClone(this.validLabel) // 数据回退到用户操作前的状态
    }
  }
}
</script>

<style lang="scss">
.custom_flow_rule.el-popover {
  border-color: #d4d4d4;
  box-shadow: 0 1px 10px 0px rgb(0 0 0 / 10%);
  margin-top: 10px;
  padding: 12px 15px;
  width: 332px;
  .rule_list {
    color: #666;
    font-size: 12px;
    line-height: 1.5;
    .rule_item {
      margin-top: 5px;
    }
    .stress {
      color: #282729;
      font-weight: bold;
    }
  }
  .popper__arrow {
    display: none;
  }
}
</style>
<style lang="scss" scoped>
.customize_box {
  max-width: calc(100% - 102px);
  padding-right: 20px;
  flex-basis: auto;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  ::v-deep .fix-box {
    color: #282729;
    height: auto !important;
    .fix-centerv1-main {
      background-color: #FBFBFB;
    }
  }
  .box_inner {
    flex-basis: 100%;
    max-width: 100%;
    line-height: 16px;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    border-right: 1px solid #e9e9e9;
    padding-right: 20px;
    white-space: nowrap;
    .title {
      white-space: nowrap;
    }
    .label_str_wrap {
      width: auto;
      color: #282729;
      font-weight: 500;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      .incre_value {
        color: #FF3973;
        font-size: 12px;
      }
    }
    .custom_flow {
      cursor: pointer;
      color: #6629E7;
      line-height: 16px;
      margin-left: 10px;
      white-space: nowrap;
    }
  }

  .custom_flow_popbox {
    padding: 10px;
    overflow: hidden auto;
    .describe {
      display: flex;
      align-items: center;
      justify-content: space-between;
      font-size: 12px;
      line-height: 16px;
      margin-bottom: 10px;
    }
    .rule_tip {
      cursor: pointer;
      color: #FF3973;
      display: flex;
      align-items: center;
      justify-content: flex-start;
    }
    .el-icon-arrow-up {
      cursor: pointer;
      color: #FF3973;
      font-size: 14px;
      transition: transform .3s;
      transform: rotateZ(180deg);
      &.reverse {
        transform: rotateZ(0);
      }
    }
    .one_item {
      display: flex;
      align-items: center;
      justify-content: space-between;
      height: 40px;
      background: #FFFFFF;
      border-radius: 2px;
      box-shadow: 0 0 0 1px #E9E9E9;
      line-height: 20px;
      padding: 8px 10px;
      &:not(:last-child) {
        margin-bottom: 10px;
      }
      .item_r {
        display: flex;
        align-items: center;
        justify-content: flex-start;
        color: #999;
      }
      .icon_minus, .icon_plus {
        cursor: pointer;
        width: 14px;
        height: 14px;
        &.disable {
          cursor: not-allowed;
        }
      }
      .count_input {
        width: 50px;
        line-height: 24px;
        margin: 0 10px;
        ::v-deep .el-input__inner {
          height: 24px;
          line-height: 24px;
          background: #FBFBFB;
          border-radius: 2px;
          border-color: #D4D4D4;
          color: #282729;
          font-size: 14px;
          font-weight: bold;
          padding: 0;
        }
      }
    }
  }
}
</style>
